import {
    Box,
    BoxProps,
    TextField,
    TextFieldProps,
    Typography,
    styled
} from "@mui/material";

import { ReactNode } from "react";

export const ResourceCardTitle = styled(Typography)(() => ({
    fontSize: "1.25rem",
    fontWeight: 700
}));

type ResourceCardProps = {
    inFocus?: boolean;
    imageCarousel: ReactNode;
    content: ReactNode;
    borderColor: BoxProps["borderColor"];
    bgColor: {
        r: number;
        g: number;
        b: number;
    };
};

export const ResourceCard = (props: ResourceCardProps) => {
    const { inFocus, imageCarousel, content, borderColor, bgColor } = props;
    return (
        <Box
            display="grid"
            gap={{ xs: 2, md: 4 }}
            flexWrap="wrap"
            gridTemplateColumns={{
                xs: "1fr",
                sm: inFocus ? "1fr 1fr" : "2fr 3fr",
                md: inFocus ? "1fr 1fr" : "2fr 5fr"
            }}
            position="relative"
            borderLeft="6px solid"
            borderColor={borderColor}
            px={{ xs: 1, md: 2 }}
            py={1.5}
            bgcolor={`rgba(
                ${bgColor.r},
                ${bgColor.g},
                ${bgColor.b},
                0.03
            )`}
            sx={{
                "&:hover": {
                    bgcolor: `rgba(
                        ${bgColor.r},
                        ${bgColor.g},
                        ${bgColor.b},
                        0.05
                    )`
                }
            }}
            width="100%"
        >
            <Box
                maxWidth="100%"
                width="100%"
                minWidth={0}
                sx={{ aspectRatio: "16 / 9" }}
                onClick={(event) => event.stopPropagation()}
            >
                {imageCarousel}
            </Box>
            {content}
        </Box>
    );
};

export const ResourceCardTextField = (props: TextFieldProps) => {
    return (
        <TextField
            fullWidth
            multiline
            {...props}
            InputProps={{
                sx: {
                    fontSize: theme => theme.typography.body2.fontSize,
                    p: 0.5,
                    backgroundColor: theme => theme.palette.common.white,
                    ...props.InputProps?.sx
                }
            }}
        />
    );
};
